"use strict";

(function ($) {
    const fixedNav = $('#fixedNav');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 600) {
            fixedNav.addClass('is-visible');
        } else {
            fixedNav.removeClass('is-visible');
        }
    });
    fixedNav.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, '300');
    });
}(jQuery));
